<template>

  <v-app id="inspire" translate="no" class="notranslate">

   
    <!-- <br/><br/><br/> <span class="ml-10 pl-10"> {{ dados_cliente }} </span> -->
    <!-- <br/><br/><br/> <span class="ml-10 pl-10"> {{ assinaturas }} </span> -->
    <!-- <br/><br/><br/> <span class="ml-10 pl-10"> {{ cliente_situacao }} </span> -->
    <!-- <br/><br/><br/> <span class="ml-10 pl-10"> {{ dias_testando }} </span> -->
    <!-- <br/><br/><br/> <span class="ml-10 pl-10"> {{ show_boleto }} </span> -->


    <!-- <center> -->
     <!-- <br/><br/> objs_whats: {{ objs_whats }} -->
     <!-- <br/><br/> zapzap_conectado:{{ zapzap_conectado }} -->
     <!-- <br/><br/> obj_dados_cliente:{{ obj_dados_cliente }} -->
     <!-- <br/><br/> tipo_de_cliente:{{ tipo_de_cliente }} -->
     <!-- </center> -->
 


    <v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>



    <v-navigation-drawer
      v-model="drawer"
      mini-variant
      :app ="true"
      :permanent="false"
      color = "grey lighten-4"
      disable-resize-watcher
      touchless
    >
    <!-- :expand-on-hover="$vuetify.breakpoint.lgAndUp"   -->
  
  

    
      <v-list-item class="px-2">
        <!-- <v-img
          :src="src_img"
          @click="navega()"
          link
        ></v-img>    -->

        <v-card
          height="40"
          width="60"
          class="blue white--text text-center "
          elevation="0"
          @click="navega()"

        >
          <div class="pa-0 mt-2">
            <v-row dense class="grey pa-0 ma-0">
              <v-col class="pa-0 px-1 blue">
                <span class="font_dsi">DSi</span>
              </v-col>

              <!-- <v-col class="pa-0 px-1 white">
                <span class="font-weight-regular pa-0 ma-0 text-caption grey--text">MedClinic</span>
              </v-col> -->
            </v-row>
          </div>
        </v-card>

      </v-list-item>

      <v-divider></v-divider>




      <!-- passo 2 -->
      <v-list
        dense
        nav
      >
        <v-list-item
          v-for= "(item, i) in items"
          :key= "i"

          :to = "item.to"  
          link
          active-class="blue--text" 
          @click.native="handleClick($event, item.to)"
        >
        
        <!-- :key= "item.title" -->

          <v-list-item-icon
          v-if="isMobile"
          >
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-item-icon>


          <v-tooltip bottom
          v-else
          >
            <template v-slot:activator="{ on, attrs }">
                  <v-icon
                  v-bind="attrs"
                  v-on="on"
                  :color="item.color"
                >
                  {{ item.icon }}
                </v-icon>
            </template>
            <span> {{ item.hint || item.title }}</span>
          </v-tooltip>

          <v-list-item-content>
            <v-list-item-title>{{ item.title }}</v-list-item-title>
            <!-- :class="[item.color+'--text'] -->
          </v-list-item-content>
        </v-list-item>

      <v-divider class="mx-0"></v-divider>
      &nbsp     

      <span @dblclick="go_copiarParaClipboard( go_saudacao(`nova atualização disponível, versão *${versao}*\n\nClique em *atualizar* ou aperte *F5* no teclado. 😉`))">
        <div v-if="SOUoA==''" class="caption py-0"  style="font-size: 0.65rem !important;"> {{ versao }} </div> 
        <div v-else class="caption red--text py-0"  style="font-size: 0.65rem !important;"> {{ versao }} </div> 
      </span>


      <a class="caption primary--text py-0 my-0"  style="font-size: 0.65rem !important;" 
        @click="atualiza_pagina_F5($event)"
      >
        atualizar
      </a> 

      <!-- <span class="count_versao"> {{ nova_atu }} </span>  -->

      <!-- AVISO DSI -->
      <v-btn
            class="ml-8"
            fab
            dark
            width="15"
            height="15"
            top
            color="red"
            style="top:-60px"
            @click="clicou_em('AVISO_DSI')"
            v-if="(nova_atu>0)&&(!isMobile)"
          >
           <span class="fs-11"> {{ nova_atu }} </span>
          </v-btn>

      
      </v-list>
    </v-navigation-drawer>

      <v-app-bar 
      v-model="app_bar"
      :app = "true"
      color="blue"
      height="45"
      :hidden="esconde"
      >
        <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      


        <v-card
          height=""
          class="grey white--text text-center ml-0  pa-0"
          elevation="4"
          v-if="(!isMobile)"
        >
          <div class="pa-0">
            <v-row dense class="grey lighten-3 pa-0 ma-0">
              <v-col class="pa-0 px-1 blue lighten-0">
                <span class="font-weight-regular pa-0 ml-1 text-h5">DSi</span>
              </v-col>

              <v-col class="pa-0 px-1 grey lighten-3 mt-1">
                <span class="font-weight-regular pa-0 ma-0 text-h7 black--text">CFC</span>
              </v-col>
            </v-row>
          </div>
        </v-card>

        <v-card class="ml-2" v-if="(!isMobile)">
          <!-- EMPURRA -->
        </v-card>

        <v-card
          height=""
          elevation="0"
          class="blue lighten-0 white--text text-center   pa-1 px-2"
        >
          <h5 v-if="isMobile" class="font-weight-regular" >{{ (empresa) }}</h5>
          <h3 v-else class="font-weight-regular" @dblclick="clicou_em('ver_ide_empresa')" >{{ (empresa) }}</h3>

        </v-card>
      


        <v-spacer></v-spacer>

              <iframe
                width="1"
                height="1"
                :src="embedUrl"
                frameborder="0"
                allow="autoplay; encrypted-media"
                allowfullscreen
                v-if="0>1"
                >
              </iframe>


     



      

      <v-chip v-if="(cliente_situacao!='ATIVO')"
        class="mr-2"  dark
        :color="(cliente_situacao == 'TESTE') ? 'orange' :'' "
        @click="clicou_em(cliente_situacao)"
      >
      {{ cliente_situacao }}  
      <span class="fs-11 ml-1" v-if="(dias_testando>0)">{{ dias_testando }} dias </span>
      
      </v-chip>





      <v-badge
        :content="dias_dif_aqui"
        :value="dias_dif_aqui"
        color="red"
        overlap
        :dot="(isMobile)"
        :class="[(dias_dif_aqui == 0) ? 'orange' : (dias_dif_aqui < 0) ? 'red' : 'primary darken-3', 'pl-1 mr-4 mt-0 white--text ' ]"
        v-if="(show_boleto) && (2>1)" 
        @click="DSi_PAGAR_PIX(true)"
      >
      <!-- :class="[(boleto_atrasado) ? 'orange': 'primary darken-3', 'pl-1 mr-4 mt-0 white--text ' ]" -->
      <!-- deep-orange accent-3 -->
      <!-- :class="[(boleto_atrasado) ? 'blue darken-3': 'blue darken-3', 'pl-1 mr-4 mt-0 white--text ' ]" -->
      <!-- white black--text pl-2 -->
      
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <a class="white--text" @click="DSi_PAGAR_PIX(true)"
              v-bind="attrs"
              v-on="on"
          >
          <span style=" text-align: right; font-size: 10px;" class="white--text pa-0 mt-2 ml-0"> 
            <span v-text="(dias_dif_aqui == 0) ? 'hoje':'dia '+ dia_vence_aqui">  </span>
          </span>  
          BOLETO 
        </a>

        </template>
        <span> Vencimento dia {{ dia_vence_aqui }}  </span>
      </v-tooltip>


      

        <v-icon 
          color="white" 
          :size="(isMobile) ? 25: 30"
          class="mr-1"
          @click="DSi_PAGAR_PIX(true)"
        >
           mdi-barcode
        </v-icon>
         <!-- BOLETO⠀ -->
         <!-- PIX DSI⠀ -->
      </v-badge>



      <!-- ABRE CHAT -->
      <!-- <v-badge
        :content="count_chat"
        :value="count_chat"
        color="red"
        overlap
        :dot="(isMobile)"
        class="mr-3"
        @click="f_show_chat()"
      >
      
        <v-icon 
          color="white" 
          @click="f_show_chat()"
          :size="(isMobile) ? 25: 28"
        >
          mdi-chat-processing
        </v-icon>
      </v-badge> -->

      <div class="text-center" v-if="(!isMobile)">
        
        <v-menu offset-y>

          <template v-slot:activator="{ on: menu }">
              <v-tooltip bottom>
                  <template v-slot:activator="{ on: tooltip }">

                    <v-chip
                      class="ma-2"
                      color="red" dark  
                      v-on="{ ...tooltip, ...menu }"
                    >
                      <v-icon left color="white" class="">
                        mdi-youtube
                      </v-icon>
                      Tutoriais
                    </v-chip>
                    
                    
                    <v-icon color="white"  class="mr-4" size="32"  
                    v-on="{ ...tooltip, ...menu }"
                    v-if="0>1"
                    >
                    <!-- v-if="(cliente_novo=='N')" -->
                      mdi-youtube
                    </v-icon>

                    
                  </template>
                  <span> Vídeos tutoriais </span>

                </v-tooltip>
                
              </template>
              

          <v-list dense>
            <v-list-item
              v-for="(item, index) in items_tutoriais"
              :key="index"
            >
                <v-icon color="error"> {{ item.icon }}</v-icon>

              <v-list-item-title @click="clicou_em(item.click)" class="hand ml-3">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>



      <!-- MODULO WHATSAPP -->
       <!-- v-if="(icone_zap)" -->
      <div class="text-center" v-if="(objs_whats && 2>1)">
        
        <v-menu offset-y>

              <template v-slot:activator="{ on, attrs }">
                  <v-icon left  class="mx-2" 
                    v-bind="attrs" v-on="on"
                    :size="(zapzap_conectado ? '27':'33')"
                    :color="(zapzap_conectado ? 'white':'yellow')"
                    @click="monta_menu_zap()"
                  >
                    mdi-whatsapp
                  </v-icon>
              </template>

          <v-list dense>
            <v-list-item
              v-for="(item, index) in items_zap"
              :key="index"
            >
                <v-icon :color="item.color"> {{ item.icon }}</v-icon>

              <v-list-item-title @click="clicou_em(item.click)" class="hand ml-3">
                {{ item.text }}
              </v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>

      </div>





      <!-- AVISO DSI -->
      <v-badge
        :content="nova_atu"
        :value="nova_atu"
        color="red"
        overlap
        :dot="(isMobile)"
        class="mr-2"
        @click="clicou_em('AVISO_DSI')"
        v-if="0>1"
      >
      
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">

          <v-icon color="white" size="27" class=""
            v-bind="attrs" v-on="on"
            @click="clicou_em('AVISO_DSI')"
          >
            mdi-information-variant
              <!-- mdi-alert-box -->
          </v-icon>
            
        </template>
        <span> Avisos e Atualizações DSi </span>
      </v-tooltip>

      </v-badge>





      <!-- ABRE LEMBRETES -->
      <v-badge
        :content="count_lembrete"
        :value="(count_lembrete>0) ? count_lembrete : ''"
        color="red"
        overlap
        :dot="(isMobile)"
        class="mr-5"
        @click="f_show_lembretes()"
      >
      
        <v-icon 
          color="white" 
          @click="f_show_lembretes()"
          :size="(isMobile) ? 25: 27"
        >
        mdi-bell
        </v-icon>
      </v-badge>
      
    

      <v-menu
        bottom
        right
        min-width="180"
      >
        <template v-slot:activator="{ on, attrs }">



          <v-icon dark 
            v-bind="attrs"
            v-on="on"
            small
            @click="monta_menus_avatar('users')"
            :color="color_super"
          >
            <!-- mdi-dots-vertical -->
            mdi-chevron-down 
          </v-icon> 

          <v-avatar
            :size="(isMobile) ? 25: 30"
            color="grey lighten-3"
            v-bind="attrs"
            v-on="on"
            @click="monta_menus_avatar('users')"
          >
            <span class="primary--text font-weight-bold"> {{user_name_abreviado}} </span>
          </v-avatar>




        </template>

        <v-list dense>

          <v-subheader class="grey lighten-3">
            <v-icon> mdi-account-circle</v-icon>
            <h4 class="ml-1"> {{ user_name }} </h4>
          </v-subheader>
          
          <v-divider class="mx-0"></v-divider>


          <!-- troca de unidade -->
          <v-list-item
            v-for="(item, i) in items_avatar"
            :key="i"
            @click="acao_menu_avatar(item.click)"
          >
            <v-list-item-title>
                {{ item.title }}
            </v-list-item-title>
            
            <v-list-item-icon>
               <v-icon :color=item.icon_color> {{ item.icon }} </v-icon>
            </v-list-item-icon>
          </v-list-item>


          <v-divider class="mx-0"></v-divider>

          <!-- <v-list-item
            link
            class="white lighten-5"
            @click="atualiza_pagina_F5()"
            >
                <v-list-item-title>Atualizar  (F5)</v-list-item-title>
                <v-list-item-icon>
                <v-icon color="primary"> mdi-refresh </v-icon>
                </v-list-item-icon>
                
            </v-list-item> -->

            <!-- <v-divider class="mx-0"></v-divider> -->

            <v-list-item
            link
            class="grey lighten-5"
            @click="logout()"
            >
                <v-list-item-title>Sair</v-list-item-title>
                <v-list-item-icon>
                <v-icon color="red"> mdi-power-standby </v-icon>
                </v-list-item-icon>
                
            </v-list-item>

        </v-list>
      </v-menu>
      
      
      <!-- <v-btn
      text
      color="white"
       
       @click="sair()">  
        Sair 
        <v-icon>mdi-power-standby</v-icon>
      </v-btn> -->

      </v-app-bar>

      <!-- aqui no class tinha um mt-1 isso dava erro de na hora de imprimir sair 2 paginas...erro bobo -->
    <v-main>
      <router-view 
        @executar="changeDrawer" 
        @executar2="ler_session"
      >
     </router-view>
      <!-- @carregar_componentes="carregar_componentes" -->



      <!-- {{ dados_cliente }} -->


  <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog_ok"
          width="auto"
          persistent
        >


          <v-card>
            <v-card-title class="text-h5 grey lighten-2">
              {{  (dialog_ok_tipo == 'conectar_zap') ? 'Concluído' : 'Concluído'  }}
            </v-card-title>

            <v-card-text>
              
            </v-card-text>

            <v-divider></v-divider>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                color="primary"
                text
                @click="clicou_em(dialog_ok_tipo), dialog_ok=false"
              >
                OK
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>


    <v-dialog v-model="dialog_ativar" width="900" persistent >


      <v-card class="">
        <v-card-title class="text-h5 orange lighten-2">
          Período de Teste Terminou
        </v-card-title>

        <v-card-text class="mt-4">
          <h3> Para continuar, selecione uma das opções abaixo:</h3>
          <br>
          <!-- <br> -->
          <!-- <span class="red--black"> Obrigado por Testar  <b> agilizar o acesso</b>, selecione a forma de pagamento <b>PIX</b>, e tente abrir o App em alguns minutos.</span> -->

        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="error"
            small
            text
            @click="dialog_ativar=false"
            v-if="0>1"
          >
            cancelar
          </v-btn>

          <v-btn
            color="error"
            small
            text
            @click="ativar_sistema('CANCELAR')"
            class="mr-10"
          >
            Cancelar Sistema
          </v-btn>

          <v-btn
            color="primary"
            small
            @click="ativar_sistema('ATIVAR')"
          >
            Continuar com o Sistema
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>



    <v-dialog v-model="dialog_bloqueado" width="900" persistent >
      <v-card class="">
        <v-card-title class="text-h5 orange lighten-2">
          Fatura Pendente
        </v-card-title>

        <v-card-text class="mt-4">
          <h3> Não identificamos o pagamento de sua fatura do dia  <b class="blue--text">{{ bloqueado_vencimento }}</b> no valor de <b class="blue--text">R$ {{ bloqueado_valor }}</b>.</h3>
          <br>
          <br>
          <span class="red--black"> Para <b> agilizar o acesso</b>, selecione a forma de pagamento <b>PIX</b>, e tente abrir o App em alguns minutos.</span>

        </v-card-text>

        <!-- <v-divider></v-divider> -->

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="error"
            small
            text
            @click="dialog_bloqueado=false"
            v-if="(souDSi)"
          >
            cancelar
          </v-btn>

          <v-btn
            color="error"
            small
            text
            @click="logout()"
          >
            fechar
          </v-btn>

          <v-btn
            color="primary"
            small
            @click="DSi_PAGAR_PIX(true)"
          >
            efetuar pagamento
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


    </v-main>

    <!-- MOSTRA LEMBRETES -->
    <div v-if="(app_bar) &&(2>1)" >
      <v-row class="mt-n10">
        <v-col>
        <LembreteVue 
        v-if="(verificou_DSi)"
        :aberto = 'show_lembretes'
        pro_tabela = 'ALERTA'
        pro_titulo = 'Lembretes'
        :pro_obj_1 = null
        :pro_obj_items = null
        :show_menu = 'false'
        @muda_aberto_lembretes="muda_aberto_lembretes"
        @muda_count_lembretes="muda_count_lembretes"
        />
        </v-col>
      </v-row>
    </div>




    <!-- MOSTRA CHAT -->
    <!-- <div v-if="(app_bar)&&(2>1)">
      <v-row>
        <v-col>
        <ChatVue 
        v-if="(verificou_DSi)"
        :aberto = 'show_chat'
        @muda_aberto="muda_aberto"
        @muda_count="muda_count"
        />
        </v-col>
      </v-row>
    </div> -->


  </v-app>
</template>

<script>


  import axios from "axios";
  import DSirotinas from './assets/js/DSi_rotinas'//chamo funcao do arquivo
  import { define_data_hora, diferenca_datas, formatarTelefoneWhatsapp, copiarParaClipboard, saudacao, mostrar_tipo_cliente } from './assets/js/DSi_basico'
  import { conectar_cliente, status_whats } from './assets/js/DSi_whats'
  // import { crud_abrir_tabela } from './assets/js/DSi_sql'


  DSirotinas.url_app()


  export default {


    components:{
      // ChatVue,
      // LembreteVue

      // IMPORTO COMPONENTES AQUI NAO PRECISA DECLARAR EM CIMA.. E NAO GERA ERRO DO URL e so chamo apos logado
      // ChatVue:     () => import("./views/chat.vue"),
      LembreteVue: () => import("./views/Lembretes.vue")
      // https://stackoverflow.com/questions/55581345/dynamic-importing-components-based-on-route
    },

  
    data: () => ({ 
      

      tipo_de_cliente:'CFC',

      playlistLink: 'https://www.youtube.com/playlist?list=PLsLit1NYXAGhT3muA4aFEule1Pa7wSSFn',


      nova_atu:0,

      versao: 'v 2.2.25',

      overlay: false,

      obj_dados_cliente : null,
      objs_whats : null,
      zapzap_conectado: false,

      items_zap: [],

      dialog_ok: false,
      dialog_ok_tipo: '',

      items_tutoriais: [],

      SOUoA:false,
      souDSi: false,

      verificou_DSi: false,
      verificou_permissoes: false,

      color_super: '',

      show_boleto: false,
      boleto_atrasado: false,
      dialog_bloqueado: false,
      dialog_ativar: false,

      bloqueado_valor:'',
      bloqueado_vencimento:'',

      dados_cliente: {},
      assinaturas: null,
      cliente_situacao :'ATIVO',

      dia_vence_aqui:'',
      dias_dif_aqui:0,
      dias_testando:0,

      show_lembretes: false,
      show_chat: false,

      count_chat:0,
      count_lembrete:0,

      items_avatar:[],  
      users_avatar: false,  

      esconde: true,
      drawer: false,
      app_bar: false,

      isMobile: false, 

      user_name:'',
      user_name_abreviado:'',
      empresa: '',
      session_bd : 'null',

      // src_img:'http://localhost/dsi.png',
      src_img:'https://dsi.app.br/dsi.png',

      items: [], 

      painel_fixo:false,  

      }),

    mounted(){
      this.meuTimer()
    },

   created(){
    this.onCreated()
   },

    
   watch: {
     

    //  empresa(){
    //    let agora  = new Date();
    //    localStorage['watch : Sessão Expirou em :'] = agora
    //    localStorage['Era para Expirar em  :'] = sessionStorage['expira']

    //    alert('Sessão Expirou');
    //    this.Logout()
    //  },

     drawer(){
      //  console.log('drawer:');
      //  console.log(this.drawer);
     },
     
     session_bd(a){
        sessionStorage['session_bd'] = a.trim()
     },

     
   },


    computed: {

      embedUrl () {
        if (!this.playlistLink) return ''

        const listId = this.playlistLink.split('list=')[1]

        return `https://www.youtube.com/embed?listType=playlist&list=${listId}&autoplay=1&mute=1&rel=0`
      }
    },



    methods:{

      async AVISOS_DSI(alertar) {

        // Pega só números da versão
        let versao = Number(this.versao.replace(/\D/g, ''));

        const versoes = [
          
        
          {
            VERSAO: .2223,
            LOG: `1-MODULO WHATSAPP\n1-Alterado o servidor API_LINK\n2-CRM`
          },
          {
            VERSAO: .2220,
            LOG: `1-MODULO CHAMADA\n2-Cria e Apaga pasta temp_1 e temp_2 para arquivos temporarios, uso no share dos comprovantes`
          },
          {
            VERSAO: 2218,
            LOG: `1-FINANCEIRO: Transferência de Saldo\n`
          },
          
          {
            VERSAO: .2217,
            LOG: `1-AGENDA: Mostrar Cadastro com IDE negativo\n2-CONFIGURAÇÕES: Empresa: Salvar dados de envio de email`
          },
        
          {
            VERSAO: 2213,
            LOG: `1-CADASTRO: Upload de Arquivos e Imagens em Atendimentos, Registros\n`
          },
        
          {
            VERSAO: 2210,
            LOG: `1-AGENDA: Mostrar Agenda Multipla\n2-FINANCEIRO: Mostra estatísticas de Recibos Impressos\n3-CADASTRO: Restaurar Cadastros Excluídos\n4-CADASTRO: Perguntas automáticas de etapa quando novo Cadastro\n`
          },
          
          {
            VERSAO: 2205,
            LOG: `1-ASAAS: Gerar NFe via API\nEnviar NFe via email e whatsapp\n`
          },
          
          {
            VERSAO: 2202,
            LOG: `1-AGENDA: Novo menu - Imprimir:\n - Agenda Geral dos Veículos\n - Quantidade por Instrutor`
          },

          {
            VERSAO: 2201,
            LOG: `1-Sequencia nos Recibos\n`
          },

          {
            VERSAO: 2200,
            LOG: "Novos Relatórios na janela Cadastro:\n1-Histórico\n2-Transferências Asaas\n3-Campo NF nos lançamentos\n4-Campo CARRO (AUTOMÁTICO) em Serviços"
          }
        ];

        // Busca a versão
        const versaoEncontrada = versoes.find(v => v.VERSAO === versao);

        if (versaoEncontrada) {

          // Conta quantos itens existem (1- 2- 3- ...)
          const total_itens = (versaoEncontrada.LOG.match(/\n/g) || []).length;
        
          // Quantidade encontrada no log
          this.nova_atu = total_itens;

          // Mostra alerta se quiser
          if (alertar) {
            // alert(versaoEncontrada.VERSAO +`\n`+ versaoEncontrada.LOG);
            alert(`Atualização da `+this.versao +`:\n\n`+ versaoEncontrada.LOG);
          }

        } else {
          console.log("Nenhum aviso para esta versão:", versao);
        }

      },

      go_saudacao(texto) {
          return saudacao(texto)
      },


      go_copiarParaClipboard(texto){
        copiarParaClipboard(texto)

        if (Notification.permission === "granted") {
          new Notification("Nova mensagem!", {
            // body: "Copiado para a Área de Trabalho",
            body: texto,
            icon: "/favicon.ico"
          });
        } else {
          Notification.requestPermission();
        }
      },

      async status_whats_go(alertar, conectar, retornar_campo ){
        let rr =  await status_whats(alertar, conectar, retornar_campo)
        // console.log('rr:', rr);
        return rr
        
      },

      async go_conectar_cliente(item, acao, origem, silencioso){
        let rr = await conectar_cliente(item, acao, origem, silencioso)
        // console.log('rrr:', rr);
        if (rr != false){

          this.overlay = true
          setTimeout(function(){
              this.dialog_ok      = true
              this.dialog_ok_tipo = 'zap_status'
              this.overlay = false
          }.bind(this), 3000);
        }
      },
      

      handleClick(event, to) {

        // ctrl pressionado
        if (event.ctrlKey || event.metaKey) {
          event.preventDefault(); // Impede o <router-link> de navegar

          let route = this.$router.resolve({path: to});
            window.open(route.href, '_blank');
        }
        // Caso contrário, deixe o <router-link> fazer a navegação normalmente
      },
      

      async clicou_em(acao){


        let link = ''

        if (acao == 'ver_ide_empresa'){
            alert(this.obj_dados_cliente.CODIGO + ' | '+this.obj_dados_cliente.TIPO_CLIENTE)
            return false
        }


        else if (acao == 'link_primeiros_passos'){
          link = 'https://youtu.be/WS8PLEAtfxg'
        }

        else if (acao == 'AVISO_DSI'){
          this.AVISOS_DSI(true)
          return false
        }

        else if (acao == 'ENCERRANDO'){
          alert('Sistema em fase de Encerramento!\nO sistema esta ativo somente para consultas e encerramento, não sendo possível adicionar novos Cadastros!')
          return false
        }

        else if (acao == 'zap_qual_numero'){
          return false
        }

        else if (acao == 'zap_fechar'){
          await this.go_conectar_cliente(this.objs_whats, 'close', 'C', true)
          return false
        }

        else if (acao == 'zap_desconectar'){
          await this.go_conectar_cliente(this.objs_whats, 'out', 'C', true)
          return false
        }

        else if (acao == 'zap_conectar'){
          await this.go_conectar_cliente(this.objs_whats, 'in', 'C', false)
          return false
        }

        else if (acao == 'zap_status'){
          // this.go_conectar_cliente(this.objs_whats, 'status', 'C')
          this.zapzap_conectado = await this.status_whats_go(false, false, 'connected')

          return false
        }

        else if (acao == 'chamada_demo'){
          link = 'https://www.youtube.com/watch?v=fPuq9GlxRr8'
        }

        else if (acao == 'link_demo_geral'){
          link = 'https://youtu.be/yqemFCGRgpw'
        }

        else if (acao == 'link_modulo_whats'){
          link = 'https://www.youtube.com/watch?v=R37AjyZudvQ'
        }

        else if (acao == 'link_enviar_whats'){
          link = 'https://youtu.be/L6ZC0p7MqFw'
        }

        else if (acao == 'link_financeiro'){
          link = 'https://www.youtube.com/watch?v=wP3kqUVW2ak'
        }

        else if (acao == 'link_alterar_contrato'){
          link = 'https://www.youtube.com/watch?v=eCIV7bosN34'
        }

        else if (acao == 'link_resolucao'){
          link = 'https://youtu.be/MUbOpgCod7E'
        }

        else if (acao == 'link_agenda_demo'){
          link = 'https://youtu.be/PdhW4sLRkwc'
        }


        if (link){
          window.open(link, '_blank', 'noopener,noreferrer');
        }

      },

      atualiza_pagina_F5(event){

        // ctrl pressionado
        if (event.ctrlKey || event.metaKey) {
            sessionStorage['lg:F12'] = 'S'//se pode abrir F12 console
            // alert('apertou Ctrl')
        }

        location.reload()
      },

      async ativar_sistema(acao){

        let sql      = ''
        let situacao = acao
        let ide_cliente = this.dados_cliente.dados_cliente.CODIGO
        var url =  sessionStorage['url']
        

        if (!ide_cliente){
          alert('Código Inválido!')
          return false
        }

        if (confirm(`Deseja mesmo ${acao} o Sistema?`)){


          this.dialog_ativar = false

          if (acao == 'CANCELAR'){
            situacao = 'CANCELADO'
          }
          else if (acao == 'ATIVAR'){
            situacao = 'ATIVO'
          }

          sql = `update clientes set SITUACAO = '${situacao}' where codigo = ${ide_cliente};`
          sql+= `update assinaturas set SITUACAO = '${situacao}' where CODIGO_CLIENTE = ${ide_cliente};`
          console.log('sql:', sql);

          let res = ''

          if (res = await this.crud_sql_canal_extra(url, sql)){
            console.log('res:', res);

            alert('Concluído')
            await this.logout()
          }
        
        }

      },


      async  crud_sql_canal_extra (url, sql) {

        const res = await axios.post(url+'clientes/canal.php', {
            acao:   6,
            meuSQL: sql
        })

        console.log(res.data);
        return res.data
      },

      async onCreated(){

        // TITULO DO PROGRAMA
        document.title = 'DSi CFC'

        //  this.ler_php()
         sessionStorage['versao'] = this.versao

         this.isMobile = window.innerWidth < 600
         this.monta_menus_avatar('padrao')

         DSirotinas.SEM_F12()
         this.SOUoA = sessionStorage['lg:USUARIO'] == 'A'


         this.AVISOS_DSI(false)

      },


      async monta_menu_zap(){


        // verifica o status quando clica...para montar os menus
        await this.clicou_em('zap_status')       


        this.items_zap = [] //limpa
        
        let numero = this.obj_dados_cliente?.SERIALIZED || 'xxd';

        if (numero) {
          numero = await formatarTelefoneWhatsapp(numero);
        }


        if (this.zapzap_conectado){
          this.items_zap.push(
            { text: 'Desconectar'          , icon: 'mdi-square' , color:'yellow' , click:'zap_fechar' },
            { text: 'Remover Dispositivo' , icon: 'mdi-close'  , color:'red'    , click:'zap_desconectar' },
          )
        }
        else{
          this.items_zap.push(
            { text: 'Conectar', icon: 'mdi-circle', color:'green', click:'zap_conectar' },
          )
        }


          this.items_zap.push(
            { text: `Número: ${numero}`, icon: 'mdi-phone', click:'zap_qual_numero' },
          )

      },

      // passo 1
      monta_menu_lateral(){

        //busco objeto no sessionStorage
        this.obj_user = JSON.parse(sessionStorage['obj_user'])
        // console.log( 'obj_user:',  this.obj_user);


        this.souDSi = (sessionStorage['souDSi'] == 'S') ? true : false


        this.items = []


        // if (this.obj_user.TIPO_CLIENTE != 'SIMPLES'){
            this.items.push(
                // { title: 'Home', icon: 'mdi-view-dashboard', to: '/home' },//mdiSitemap 
                // { title: 'Acontecendo', icon: 'mdi-text-box-multiple ', to:'/news' },
                // { title: 'Agenda', icon: 'mdi-calendar-clock ', to: '/agenda' },
                // { index:0, title: 'Inicio', icon: 'mdi-home-analytics ', color:'red', to:'/home' },
                { index:1, title: 'Cadastro', icon: 'mdi-account', color:'', to:'/cadastro' },
            )
        // }


        // tipo de cliente SIMPLES nao mostra agenda
        // if (this.obj_user.TIPO_CLIENTE != 'CHAMADA'){
        //     sessionStorage['chamada_show'] = 'S'
        //     this.items.push(
        //         { index:4, title: 'Chamada',  icon: 'mdi-calendar-clock',color:'red', to: '/chamada', janela:'chamada' },//mdi-view-list
        //     )
        // }



        if ( (this.obj_user.SUPER=='S') || (this.obj_user.FINANCEIRO_R=='S') || (this.obj_user.FINANCEIRO_R=='L')|| (this.obj_user.FINANCEIRO_R=='B')){
          this.items.push(
            { index:2, title: 'Financeiro', icon: 'mdi-chart-bar ',color:'', to:'/financeiro', janela:'financeiro' },
          )
        }

        if (this.souDSi){
          
          // habilitar isso ou nao via modulo??
          // sessionStorage['agenda_show'] = 'S'

          if (this.obj_user.SUPER=='S'){
              this.items.push(
                { index:3, title: 'DSi', icon: 'mdi-home',color:'', to: '/dsi', janela:'dsi' },  // mdi-google-downasau
                // { index:4, title: 'Agenda',  icon: 'mdi-calendar-clock',color:'', to: '/agenda', janela:'agenda' },//mdi-view-list
              )
          }
        }

        

        // tipo de cliente SIMPLES nao mostra agenda
        if (this.obj_user.TIPO_CLIENTE != 'SIMPLES'){
            sessionStorage['agenda_show'] = 'S'
            this.items.push(
                { index:4, title: 'Agenda',  icon: 'mdi-calendar-clock',color:'', to: '/agenda', janela:'agenda' },//mdi-view-list
            )
        }


        // if (this.obj_user.SUPER=='S'){
        //   this.items.push(
        //     // { index:5, title: 'Configurações', icon: 'mdi-cog', color:'',to: '/configuracoes', janela: 'configuracoes' }, //mdi-folder-cog
        //     { index:5, title: 'Configurações', icon: 'mdi-car-cog', color:'',to: '/configuracoes', hint:'Veículos' }, //mdi-folder-cog
        //   )
        // }

        // if (this.SOUoA){
          this.items.push(
            { index:5, title: 'Campanhas', icon: 'mdi-whatsapp',color:'', to: '/WhatsLab', janela:'WhatsLab' },//mdi-view-list
          )
        // }

        if ( (this.obj_user.SUPER=='S') || (this.obj_user.TABELAS_R=='S')){
          this.items.push(
            { index:4, title: 'Configurações', icon: 'mdi-cogs',color:'', to: '/tabelas', janela:'tabelas' },//mdi-view-list
            // { index:4, title: 'Tabelas', icon: 'mdi-view-list',color:'', to: '/tabelas', janela:'tabelas' },//mdi-view-list
          )
        }


        // OCULTO DEPENDENDO DO TIPO DE CLIENTE
        // if (this.mostrar_tipo_cliente('CHAMADA')){
        if (this.tipo_de_cliente=='CHAMADA'){
            this.items = this.items.filter(x => x.janela !== "financeiro");
            this.items = this.items.filter(x => x.janela !== "WhatsLab");
        }






        // monta menu tutoriais conforme o tipo de cliente
        if (this.tipo_de_cliente=='CFC'){

          this.items_tutoriais = [
            { text: 'Primeiros Passos', icon: 'mdi-cogs', click:'link_primeiros_passos' },
            { text: 'Demonstração', icon: 'mdi-youtube', click:'link_demo_geral' },
            { text: 'Financeiro', icon: 'mdi-chart-bar', click:'link_financeiro' },
            { text: 'Módulo WhatsApp', icon: 'mdi-whatsapp', click:'link_modulo_whats' },
            { text: 'Enviar WhatsApp', icon: 'mdi-whatsapp', click:'link_enviar_whats' },
            { text: 'Alterar Contrato / Impressão', icon: 'mdi-file-document-multiple-outline', click:'link_alterar_contrato' },
            { text: 'Agenda de Aulas', icon: 'mdi-calendar-clock', click:'link_agenda_demo' },
            { text: 'Alterar Tamanho da Tela', icon: 'mdi-monitor-screenshot', click:'link_resolucao' },
          ]

        }

        else if (this.tipo_de_cliente=='CHAMADA'){
          this.items_tutoriais = [
            { text: 'Demonstração', icon: 'mdi-youtube', click:'chamada_demo' },
          ]
        }




      },


      muda_aberto_lembretes(valor){
        this.show_lembretes = valor
      },

      muda_count_lembretes(valor){
        this.count_lembrete = valor 

        //aproveito essa função que executa somente apos logado
        this.refresh_app()
      },

      f_show_lembretes(){
        this.show_lembretes =!this.show_lembretes
      },

      f_show_chat(){
        this.show_chat =!this.show_chat
      },

      muda_aberto(valor){
        this.show_chat = valor
      },

      muda_count(valor){
        this.count_chat = valor 

        if (valor>0){
          document.title = `(${valor}) `+ sessionStorage['emp_title']
        }
        else{
          document.title = sessionStorage['emp_title']
        }
        

        //aproveito essa função que executa somente apos logado
        // this.refresh_app()
      },

      async refresh_app(){
        console.log('Refresh App.vue: cadastro e financeiro');

        if (!this.verificou_permissoes){
          this.monta_menu_lateral()
          this.verificou_permissoes = true
        }

        if (!this.verificou_DSi){
          
          await this.DSi_GERAR_PARCELA()
          this.verificou_DSi = true

        }


        // verifica qt de novos alertas
        let cc = sessionStorage['session_count_alerta']
        if (cc>=0){
          // alert(sessionStorage['session_count_alerta'])
          this.count_lembrete = cc
        }

      },

      async DSi_PAGAR_PIX(ver_boleto){

        console.log('DSi_PAGAR_PIX:');

        let IDE =  sessionStorage['emp_ide'];

        let link = ''
        let teste = sessionStorage['url'];
        if (teste == '/api/'){
          link = `http://localhost/vue_cfc/public/clientes/?token=pi45i${IDE}`//teste
        }
        else{
          link = `https://dsi.app.br/f/c/clientes/?token=pi45i${IDE}`//produção
        }

        const res = await axios.get(link);
        // console.log(res);
        console.log(res.data);

        //isso daqui é lido la em App.vue
        sessionStorage['boleto_mostrar']  = 'S'
        sessionStorage['boleto_atrasado'] = '?'

        if (res.data.id_pix){//gerou ok

          if (ver_boleto){
             window.open(res.data.pagina_retorno, '_blank');
          }


          //caso clique em pagar.. gera um timer para ver se pagou ou nao
          setTimeout(function(){
            this.DSi_GERAR_PARCELA()  
            console.log('TIMER: DSi_GERAR_PARCELA');
          }.bind(this), 120000);//atualiza em 2 minutos

        }

      },

      async DSi_GERAR_PARCELA(){

        // BUSCO DADOS DO CLIENTE.. E DA PARCELA

        define_data_hora(this)//passo o this para que la ele defina as variaveis daqui

        console.log('DSi_GERAR_PARCELA:');

        let IDE =  sessionStorage['emp_ide'];

        let link = ''
        let teste = sessionStorage['url'];
        if (teste == '/api/'){
          link = `http://localhost/vue_cfc/public/clientes/?token=ci45i${IDE}`//teste
        }
        else{
          link = `https://dsi.app.br/f/c/clientes/?token=ci45i${IDE}`//produção
        }

        const res = await axios.get(link);

        console.log('DSi_GERAR_PARCELA:', res.data);


        await fazer(this, res.data)

        async function fazer(that, dados){


          // console.log('fazer:',dados);
          sessionStorage['obj_dados_cliente']  =  JSON.stringify(dados.dados_cliente)   
          that.obj_dados_cliente               =  (dados.dados_cliente)
          // console.log('dados.dados_cliente::', dados.dados_cliente);    


          that.dados_cliente        = dados

          that.cliente_situacao     = dados.dados_cliente?.SITUACAO
          that.bloqueado_vencimento = dados.dados_parcela?.x_DATA_VENCIMENTO
          that.bloqueado_valor      = dados.dados_parcela?.double_VALOR
          that.dialog_bloqueado     = (dados.bloquear == 'S')

          // console.log('gerar_pix_id:', dados.gerar_pix_id);



          // verifica se cliente esta testando..conta quantos dias faltam
          let dd_teste = 0
          if (that.cliente_situacao == 'TESTE'){
            
            dd_teste =  await diferenca_datas(that.today, dados.dados_cliente?.DATA_TESTE_ACABA)
            that.dias_testando = dd_teste

            if (dd_teste<=0){
              that.dialog_ativar = true
            }

          }

          if (dados.gerar_pix_id == 'S'){
              //  that.DSi_PAGAR_PIX(false) //gera a parcela pix 
          }

        
          //pega dados das assinaturas..procura modulo zap
          // let assinaturas = ''


          let zapzap      = {}
          if (dados.dados_assinatura){

            // console.log('assinaturas:', dados.dados_assinatura);
            that.assinaturas = dados.dados_assinatura

            // alert(dados.dados_assinatura.length)

            zapzap =  that.assinaturas.map((x) => x); //clonando array copiar array

            zapzap = zapzap.filter(x => x.SERVICO === 'MODULO WHATSAPP'); //clonando array copiar array
            // zapzap = this.assinaturas.filter(x => x.SERVICO === 'MODULO WHATSAPP'); //clonando array copiar array
            zapzap = zapzap[0]

            // console.log('zapzap:', zapzap);
          }


          that.objs_whats = zapzap

          if (zapzap){

            sessionStorage['config_whats']   =  JSON.stringify(zapzap)
            sessionStorage['zapzap_mostrar'] = true

            that.zapzap_conectado = await that.status_whats_go(false, false, 'connected')
          }
          else{
            sessionStorage['config_whats']   =  JSON.stringify(false)
            sessionStorage['zapzap_mostrar'] = false
          }

        }


        

          

        let dia_vence = 0
        if (res.data.dados_parcela?.DATA_VENCIMENTO ){//pega pelo vencimento
          let aux = res.data.dados_parcela?.DATA_VENCIMENTO
          aux = aux.substring(8,10)
          dia_vence = parseInt(aux)
        }
        else{
          dia_vence = res.data.dados_cliente?.DIA_VENCIMENTO //senao pega pela dava vencimento salvo no cadastro do cliente
        }

        // sessionStorage['dia_vence'] = dia_vence
        this.dia_vence_aqui = dia_vence
        // this.dia_vence_aqui = res.data.dados_parcela?.x_DATA_VENCIMENTO


        let pago      = (res.data.dados_parcela?.PAGO == 'S') ? 'S' : 'N'
        let dia_hoje  = this.dia_hoje
        let dias_dif = 0
        let mostrar = 'N'
        let atrasado = res.data.atrasado

        // console.log('pago:'+pago);

        if (pago == 'S'){
            mostrar = 'N'
        }
        else {

          dias_dif = parseInt(dia_vence) - parseInt(dia_hoje)
          this.dias_dif_aqui = await diferenca_datas(this.today, res.data.dados_parcela?.DATA_VENCIMENTO)

          if (atrasado == 'S'){
              mostrar = 'S'
          }
          else{
              console.log('dia_vence: '+dia_vence+' hoje: '+this.dia_hoje + ' dias_dif: '+dias_dif)
            

              // somente mostra boleto se cliente estiver ATIVO
              if ((dias_dif <=10) && (dias_dif >=0) && (res.data.dados_cliente.SITUACAO == 'ATIVO') ){
                console.log('PODE MOSTRAR');
                mostrar = 'S'
              }
          }

        }

        if (mostrar){
           if (this.dados_cliente.dados_assinatura.length <1){
            mostrar = 'N' 
           }
        }


        // console.log('mostrar:'+ mostrar);
        // console.log('atrasado:'+ atrasado);

        // SOMENTE SE FOR SUPER USER
        if ( sessionStorage['lg:S'] == 'S'){
          this.show_boleto     = (mostrar=='S') ? true : false
          this.boleto_atrasado = (atrasado == 'S') ? true : false

          this.color_super = 'black'
        }
        else {
          this.show_boleto     = false
          this.boleto_atrasado = false
          this.color_super = ''
        }
        // res.data.bloquear

      },


      monta_menus_avatar(qual){


        if (qual == 'padrao'){
          // this.items_avatar.push( { title: 'Sair', icon: 'mdi-power-standby', icon_color: "red", click: 'sair' } )
        }
        else if (qual == 'users'){

            if (!this.users_avatar){
            //  SOMENTE 1 VEZ

            if (sessionStorage['box']){
              
              let box = sessionStorage['box']
              this.users_avatar = true

              let users = JSON.parse(box);

              // console.log(users);

              if (users?.length>1){

                for (let i = 0; i < users?.length; i++) {
                    if (users[i].EMPRESA_CODIGO != sessionStorage['lg:IDE']){//nao coloca o DB atual
                       this.items_avatar.unshift( { title: users[i].EMPRESA_NOME, icon: 'mdi-cube-outline', icon_color: "blue", click: {'acao' :'change', valor : users[i]} } )
                    }
                }
              }
            } 
          }
        }
      },


      acao_menu_avatar(item){
        // if (acao=='sair'){
        //   this.sair()
        // }
        // console.log(item);

        // console.log(item.acao);
        if (item.acao == 'change'){
          // console.log(item.valor)

            console.log('TROCA EMPRESA');
            // alert('TROCA EMPRESA')


            // limpa session clear session
            sessionStorage['on_create_cadastro']  = ''
            sessionStorage['obj_all_user']        = ''

            sessionStorage['config_pix']          = ''
            sessionStorage['config_whats']        = ''

            // Agenda.vue
            sessionStorage['veiculo_selecionado']    = ''
            sessionStorage['instrutor_selecionado']  = ''
            sessionStorage['cadastro_selecionado']   = ''

            // Cadastro.vue
            sessionStorage['ja_count_niver']         = 0

            this.verificou_permissoes = false
            this.verificou_DSi = false
            this.items_avatar = []
            this.users_avatar = false //atualiza os menus de box
            sessionStorage['box_selecionado'] = JSON.stringify(item.valor)
            
            // location.reload();//F5 na pagina para puxar atualizacao
            this.$router.push('/')//redireciono para a pagina do router
        
        }
        
      },

      abrevia_nomes(entra,coringa){
        let partes = entra.split(coringa);

        // console.log(partes);

        let A = ''
        let B = ''

        A = partes[0][0]
        B = ''
        
        if (partes.length>=2){
          B = partes[1][0]
        }
        
        let r = ''

        if (A){ r  = A}
        if (B){ r += B}

        return r
      },


      navega(){
        let href="https://sistemasdsi.com.br/"
        window.open(href,'_blank');
      },


      async logout(){
        // TEM OUTRO SAIR QUE FICA NO DSIBASICO, USO LA PRA SAIR QUANDO ESTA LOGOUT

        //  this.$router.push('/')//redireciona para a pagina login


        sessionStorage['buffer']        = 'SS'
        sessionStorage['refresh_size']  = 'wMPGu87'
        sessionStorage['logout']        = 'S'

        this.dialog_bloqueado = false

        this.$router.push('/')//redireciona para a pagina login



        // sessionStorage['fez_logout'] = 'S'
        // sessionStorage['created_cadastro'] = 'N'

        // const res = await axios.post(url+'logado.php', {
        //   acao : 'logout'
        // })
        //  window.location.href = url;
      } ,

      changeDrawer (newDrawer) {

        this.app_bar = newDrawer

        // alert(newDrawer)
        if (this.$vuetify.breakpoint.mdAndDown){
          this.drawer = false
          // alert('md and down')
        }else{
          this.drawer = newDrawer
        }

        

        if (newDrawer == true){
          this.esconde = false
        }
        else{
          this.esconde = true
        }
      },

      async ler_session(){//estou chamando isso no logado() da agenda.vue via emit

        // EXECUTA SOMENTE 1 VEZ

        // if (this.empresa != sessionStorage['emp_nome']){

          this.tipo_de_cliente = mostrar_tipo_cliente()

          this.user_name = this.read_sessionStorage('lg:USUARIO')

          this.user_name_abreviado = this.abrevia_nomes(this.user_name,' ')

          this.src_img = sessionStorage['url_base'] +'/dsi.png'

          // this.empresa = sessionStorage['lg:EMPRESA']
          this.empresa = sessionStorage['emp_nome']


          this.refresh_app()

          // alert('app.vue ler_sessoion')
        // }

      },

     read_sessionStorage($name,$to){
        if (sessionStorage[$name]) {
           return sessionStorage[$name]
        } 
     },


      meuTimer(){

      setTimeout(function(){

      }.bind(this), 100);//usar esse .bind(this) para chamar funcoes com o setTimeout
      },
    }
  }
</script>

<style>


@media print {
    .no-print {
      display: none !important;
    }

    .v-app,
    .v-footer,
    .v-navigation-drawer,
    .v-card-actions,
    .v-toolbar {
      display: none !important;
    }

 }

 
 .hand:hover {
  cursor: pointer; /* Muda o cursor para a mão ao passar o mouse sobre o container */
 }

  .count_versao {
   position: relative !important;
   top: -55px;
   font-size: 90%;
   vertical-align: super;
   color: red;
   margin-left: 35px;
  }

</style>

